import type { ProviderKeyWithAll } from 'entities/provider'

import { PROVIDER_BY_KEY } from './consts'

const getProviderByKey = (providerKey: ProviderKeyWithAll) => {
  return PROVIDER_BY_KEY[providerKey]
}

export default {
  getProviderByKey,
}
